import React from 'react'
import PropTypes from 'prop-types'
import TextArea from '../../inputs/text-area'
import MultiSelect from '../../inputs/multi-select'

const Other = ({ hidden, register, control, setValue }) => {
  const colorOptions = [ 
    { value: 'Red', label: 'Red', className: 'color-value red' },
    { value: 'Blue', label: 'Blue', className: 'color-value blue' },
    { value: 'Green', label: 'Green', className: 'color-value green' },
    { value: 'Yellow', label: 'Yellow', className: 'color-value dark-color yellow' },
    { value: 'Purple', label: 'Purple', className: 'color-value purple' },
    { value: 'Pink', label: 'Pink', className: 'color-value pink' },
    { value: 'Orange', label: 'Orange', className: 'color-value orange' },
    { value: 'Brown', label: 'Brown', className: 'color-value brown' },
    { value: 'Black', label: 'Black', className: 'color-value black' },
    { value: 'White', label: 'White', className: 'color-value dark-color white' },
  ]

  return <div className='step-section' hidden={hidden}>
    <TextArea
      {...register('notes')}
      label='Notes'
      onChange={(e) => setValue('notes', e.target.value)}
    />
    <MultiSelect 
      name='color'
      label='Color (up to 3 colors)'
      options={colorOptions}
      limit={3}
      control={control}
    />
  </div>
}

Other.propTypes = {
  hidden: PropTypes.bool.isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
}

export default Other
